import { colors } from '../../constants';
const MuiLink = {
  root: {
    fontWeight: 'bold',
    textUnderlineOffset: '.3em',
    '&:hover,&:focus': {
      color: colors.oriGrey[600]
    }
  },
  underlineAlways: {
    textDecorationThickness: '2px'
  }
};
export default MuiLink;